import { $ } from '../../utils/dom';
import videojs from 'video.js';
import localizationDE from 'video.js/dist/lang/de.json';
import additionalTranslationDE from './additionalTranslations/de.json';
// import { pluginAriaLiveStatus } from './plugins/aria-live-status/aria-live-status';
import { pluginAudioDescription } from './plugins/audio-description/audio-description';
import { pluginA11yTooltips } from './plugins/a11y-tooltips/a11y-tooltips';
import { pluginAddLocalizations } from './plugins/add-localizations/add-localizations';

class Player {
  constructor(params) {
    this.player = params.player;
    this.mainSrc = $('video, audio', this.player);
    this.mediumType = this.mainSrc.nodeName.toLowerCase();
    this.defaultConfig = {
      fluid: true,
      language: $('html').getAttribute('lang') || 'de',
      aspectRatio: this.mediumType === 'video' ? '16:9' : undefined,
      audioOnlyMode: this.mediumType === 'audio',
      controls: true,
      playbackRates: [0.5, 1, 1.5],
      controlBar: {
        pictureInPictureToggle: false,
      },
    };
    this.config = Object.assign({}, this.defaultConfig, params.config || {});
    this.playerInstance = undefined;
  }

  init = () => {
    window.videojs = window.videojs || videojs;
    this.setupPlayer(window.videojs);
  };

  destroy = () => {
    this.playerInstance && this.playerInstance.destroy();
  };

  setupPlayer(videojs) {
    if (this.player?.dataset?.cookieBlockYoutube) {
      import('videojs-youtube').then(() => {
        this.mainSrc.dataset.setup = this.player.dataset?.cookieBlockYoutube;
        this.initCore(videojs);
      });
      return;
    }

    if (this.player?.dataset?.cookieBlockVimeo) {
      import('videojs-vimeo-tech').then(() => {
        this.mainSrc.dataset.setup = this.player.dataset?.cookieBlockVimeo;
        this.initCore(videojs);
      });
      return;
    }

    this.initCore(videojs);
  }

  initCore(videojs) {
    this.prepareVideoJs(videojs);
    const player = videojs(this.mainSrc, this.config);
    this.playerInstance = player;
    this.launchPlugins(player);
  }

  prepareVideoJs(videojs) {
    this.addLocalization(videojs);
    this.registerPlugins(videojs);
  }

  addLocalization(videojs) {
    const lang = this.config.language;
    if (lang === 'de') {
      videojs.addLanguage(this.config.language, localizationDE);
      videojs.addLanguage(this.config.language, additionalTranslationDE);
    }
  }

  registerPlugins(videojs) {
    // pluginAriaLiveStatus(videojs);
    pluginAudioDescription(videojs);
    pluginAddLocalizations(videojs);
    pluginA11yTooltips(videojs);
  }

  launchPlugins(player) {
    // videojs.getPlugin('ariaLiveStatus')(player);
    videojs.getPlugin('audioDescription')(player);
    videojs.getPlugin('addLocalizations')(player);
    // a11yTooltips has to be after addLocalization execution in order to turn added localizations to tooltips.
    videojs.getPlugin('a11yTooltips')(player);
  }
}

export { Player };
